<template>
  <div class="item" :class="'label__' + item.labelPosition">
    <div class="content" v-html="item.content"></div>
  </div>
</template>
<script>
import { ft } from '../../../lib/utils.js';

const LABELS = {
  staticResourcePlaceholder: ft('i18n_common_static_resource_placeholder', '静态资源占位符')
};

// 属性信息展示卡 - 单条模式
export default {
  name: 'item-html',
  props: {
    item: {
      type: Object,
      default: function () {
        return {
          content: `<p>${LABELS.staticResourcePlaceholder}</p>`
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
